import React, {useState, useEffect} from 'react';
import Axios from 'axios';
import Main from './Main';
import {
    Chip,
    Spinner,
    Typography
} from "@material-tailwind/react";

export default function Diezmos ({id_iglesia}) {

const [datos,setDatos] = useState([]);
const [buscandoDatos,setBuscandoDatos] = useState(false);
const TABLE_HEAD = ["Periodo", "Estado"];

useEffect(() => {
    const obtenerDatos = async () => {
        setBuscandoDatos(true)
        try{
            const {data} = await Axios.get(`/api/tablasgenerales/mesesdiezmados/${id_iglesia}`)

            setDatos(data)
            setBuscandoDatos(false)

        } catch(err){
            console.log(err)
            setBuscandoDatos(false)
        }
    }
    obtenerDatos()               
},[id_iglesia])

    if (buscandoDatos){
        return (          
            <Main center alinear>
                <div className='flex flex-col justify-center items-center'>
                    <Spinner className="h-12 w-12" />
                    <span className="cargando font-semibold text-[15px]">Buscando diezmos...</span>
                </div>
            </Main>
        )
    };    

    return (
        <table className="mt-4 w-full lg:min-w-max table-auto text-left">
            <thead>
            <tr>
                {TABLE_HEAD.map((head) => (
                <th
                    key={head}
                    className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4"
                >
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal leading-none opacity-70"
                    >
                    {head}
                    </Typography>
                </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {[...datos].reverse().map(
                ({ iglesia, periodo, diezmo }, index) => {
                const classes = "p-4";
                return (
                    <tr key={index}>
                        <td className={classes}>
                            <div className="flex flex-col">
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                >
                                    {periodo}
                                </Typography>
                            </div>
                        </td>
                        <td className={classes}>
                            <div className="w-max">
                                <Chip
                                    variant="ghost"
                                    size="sm"
                                    value={diezmo !== 0 ? "Presentado" : "No Presentado"}
                                    color={diezmo !== 0 ? "green" : "red"}
                                />
                            </div>
                        </td>
                    </tr>
                );
                },
            )}
            </tbody>
        </table>
    )
}